import React from "react";
import { FaBriefcase } from "react-icons/fa";
import SectionHeader from "./SectionHeader";
import useRevealOnScroll from "../hooks/useRevealOnScroll";
import { useLanguage } from "../context/LanguageContext";
import translations from "../i18n/translations";

const Experience = () => {
  const { elementRef, isVisible } = useRevealOnScroll();
  const { language } = useLanguage();
  const t = translations[language];
  const experiences = t.experience.items;

  return (
    <section
      id="experience"
      ref={elementRef}
      className={`px-6 py-20 md:px-16 lg:px-28 ${
        isVisible ? "animate-fade-in-up" : ""
      }`}
    >
      <div className="mx-auto max-w-5xl">
        <SectionHeader
          icon={<FaBriefcase />}
          eyebrow={t.experience.eyebrow}
          title={t.experience.title}
        />

        <div className="mt-12 space-y-6">
          {experiences.map((exp, index) => (
            <article
              key={exp.id}
              className={`rounded-lg bg-gray-800/90 p-6 text-white shadow-lg ring-1 ring-gray-700 transition duration-500 ${
                isVisible ? "animate-fade-in-up" : ""
              }`}
              style={{ animationDelay: `${index * 120}ms` }}
            >
              <div className="flex flex-col justify-between gap-2 md:flex-row md:items-baseline">
                <h3 className="text-lg font-semibold text-coding-color">
                  {exp.title}
                </h3>
                <p className="text-sm text-gray-300">{exp.timeframe}</p>
              </div>
              <p className="mt-1 text-sm text-gray-300">@ {exp.company}</p>
              <ul className="mt-3 list-inside list-disc space-y-1 text-base text-gray-100">
                {exp.bullets.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
